"use client";

import { Header2, Header3, P1, P2 } from "@bumble/ui-kit";
import styles from "./Locations.module.css";
import MaxWidth from "@/components/MaxWidth";
import { stripOuterPTag } from "@/lib/utils/stripOuterPTag";
const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";
export interface LocationCardData {
  id?: string;
  title?: string | null;
  copy?: string | null;
  image?: {
    url?: string | null;
    alt?: string | null;
  } | null;
}
export interface LocationBlockData {
  title?: string | null;
  copy?: string | null;
  cards?: LocationCardData[];
}
interface Props {
  data?: LocationBlockData;
}
export default function Locations({
  data
}: Props) {
  const title = data?.title?.trim() ?? "";
  const copy = data?.copy?.trim() ?? "";
  const locations = data?.cards?.map(card => ({
    id: card.id,
    location: card.title ?? "",
    text: card.copy ?? "",
    image: card.image?.url || PLACEHOLDER_IMAGE,
    imageAlt: card.image?.alt ?? card.title ?? ""
  })) ?? [];
  if (!title && !copy && locations.length === 0) {
    return null;
  }
  return <MaxWidth>
      <div className={styles.locations}>
        <div className={styles.copy}>
          {title ? <Header2>{title}</Header2> : null}
          {copy ? <P1 html={stripOuterPTag(copy)} /> : null}
        </div>

        {locations.length > 0 ? <div className={styles.cards}>
            {locations.map((location, index) => {
          return <div key={location.id ?? index} className={styles.card}>
                  <div className={styles.card__copy}>
                    <Header3>{location.location}</Header3>
                    {location.text ? <P2 html={stripOuterPTag(location.text)} /> : null}
                  </div>

                  <div className={styles.card__image}>
                    <img src={location.image} alt={location.imageAlt || location.location} loading="lazy" />
                  </div>
                </div>;
        })}
          </div> : null}
      </div>
    </MaxWidth>;
}